<script setup>
import { ref } from 'vue';
import Avatar from 'next/avatar/Avatar.vue';
import ContactDetailsDialog from 'dashboard/components-next/Contacts/ContactDetailsDialog.vue';

defineProps({
  contact: { type: Object, default: () => ({}) },
});

const dialogRef = ref(null);

const openDialog = () => dialogRef.value?.open();
</script>

<template>
  <div>
    <button
      type="button"
      class="flex items-center w-full gap-3 p-2 -mx-2 text-left transition-colors rounded-lg hover:bg-n-slate-2 dark:hover:bg-n-solid-2"
      @click="openDialog"
    >
      <Avatar
        :src="contact.thumbnail"
        :name="contact.name"
        :size="32"
        rounded-full
        hide-offline-status
      />
      <div class="flex flex-col min-w-0">
        <span class="text-sm font-medium truncate text-n-slate-12">
          {{ contact.name }}
        </span>
        <span v-if="contact.email" class="text-xs truncate text-n-slate-11">
          {{ contact.email }}
        </span>
        <span
          v-else-if="contact.phone_number"
          class="text-xs truncate text-n-slate-11"
        >
          {{ contact.phone_number }}
        </span>
      </div>
    </button>

    <ContactDetailsDialog ref="dialogRef" :contact="contact" />
  </div>
</template>
